import { render } from "./UsersSalaryViewAddDeductionModal.vue?vue&type=template&id=44013e84"
import script from "./UsersSalaryViewAddDeductionModal.vue?vue&type=script&lang=js"
export * from "./UsersSalaryViewAddDeductionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__